<template>
    <div class="notification margin-bottom-lg padding-bottom-sm border-bottom text-component" v-bind:class="{ 'notification--closed' : closed, 'notification--unread' : ! isRead()}">
        <a
            href=""
            class="reset cursor-pointer block width-100% text-left text-decoration-none hover:text-decoration-underline"
            :aria-controls="'alert_body_' + notification.alert_id" :aria-expanded="[closed ? 'false' : 'true']"
            v-on:click="toggle($event)"
        >
            <h3 class="font-normal text-md margin-bottom-sm">{{notification.title}}</h3>
            
            <div class="notification__content margin-bottom-sm" :id="'alert_body_' + notification.alert_id">
                <p>{{notification.description}}</p>
                <p v-if="notification.custom_url && protocol_is_valid(notification.custom_url)">
                    <a class="js-notice-no-close" :href="notification.custom_url">{{notification.alert_cta}}</a>
                </p>
            </div>
            <p><strong>{{notification.human_date}}</strong></p>
        </a>
    </div>
</template>
<script>
import {actions, getters, setters} from './store';
export default {
    props:[
        'notification'
    ],
    data() {
        return {
            closed :true,
            unread: true,
        }
    },
    mounted() {
        this.id =  this._uid
    },
    computed: {
        
        
    },
  
    methods: {
        open() {
            this.closed = false;
            setters.isRead(this.notification.alert_id);
        },
        close() {
            this.closed = true;
        },
        toggle($event) {
            
            if ($event.target.classList.contains('js-notice-no-close')) {
                return;
            }
            $event.preventDefault();
            if (this.closed) {
                this.open()
            } else {
                this.close()
            }
            
            
            // setters.isRead(! getters.isRead());
        },
        isRead() {
            return getters.isRead(this.notification.alert_id)
        },

        protocol_is_valid(url){
            if (typeof url !== 'string') {
                return false;
            }

            const value = url.trim();
            if (!value.length) {
                return false;
            }

            try {
                const parsed = new URL(value, window.location.href);
                return parsed.protocol === 'http:' || parsed.protocol === 'https:';
            } catch (error) {
                return false;
            }
        }
    }
}
</script>

<style scoped>
    .notification {
        position: relative;
        --content-height: 17px;
    }
    .notification--closed .notification__content {
        height: var(--content-height);
        height: calc(var(--content-height) * 3);
        overflow: hidden;
        position: relative;
    }
    .notification--closed .notification__content:after {
        display: block;
        content: '';
        width: 100%;
        height: 80%;
        bottom: 0;
        left: 0;
        position: absolute;
        /* background: linear-gradient(180deg, transparent 25%, var(--color-white) 100%); */
        background: linear-gradient(180deg, transparent 25%, var(--color-white) 67%, var(--color-white) 100%);
        /* background-image: linear-gradient(180deg, transparent, var(--color-background)); */
    }
    .notification--unread:before {
        display: block;
        content:'';
        width: 5px;
        height: 5px;
        border-radius: 999em;
        background-color: var(--color-primary);
        position: absolute;
        top: 10px;
        right: 0px;
    }
</style>
